
import React, { useState } from 'react';

const DateInput = ({ value, onClick, disable = false }) => (
    <div className="input-group input-group-button" onClick={disable ? undefined: onClick}>
        <input type="text" className="form-control" value={value} disabled={disable}></input>
        <span className={disable ? "input-group-addon btn btn-secondary": "input-group-addon btn btn-primary"}><i className="fas fa-calendar-alt" /></span>
    </div>
)

export default DateInput